// TODO: Deprecate this query in favor of the new one
import { QueryHookOptions, gql } from '@apollo/client'
import {
  BaseOfferBlock,
  BrandTabsBlockFragment,
  CategoryTabsBlockFragment,
  FeaturedOfferBlockFragment,
  FeaturedOffersBlockFragment,
  ForYouBlockFragment,
  OfferCollectionBlockFragment,
  OfferGridBlockFragment,
  SearchBlockFragment,
} from 'app/features/offer/blocks'
import {
  FeaturedContentBlockFragment,
  FeaturedContentCarouselBlockFragment,
  RichTextBlockFragment,
  SpacerBlockFragment,
} from 'app/features/shared/blocks'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchDiscountsHome($draft: Boolean!) {
    DiscountsHome(draft: $draft) {
      content {
        ${BrandTabsBlockFragment.partialFragment}
        ${CategoryTabsBlockFragment.partialFragment}
        ${FeaturedContentBlockFragment.partialFragment}
        ${FeaturedContentCarouselBlockFragment.partialFragment}
        ${FeaturedOfferBlockFragment.partialFragment}
        ${FeaturedOffersBlockFragment.partialFragment}
        ${ForYouBlockFragment.partialFragment}
        ${OfferCollectionBlockFragment.partialFragment}
        ${OfferGridBlockFragment.partialFragment}
        ${RichTextBlockFragment.partialFragment}
        ${SearchBlockFragment.partialFragment}
        ${SpacerBlockFragment.partialFragment}
      }
      meta {
        title
        description
      }
    }
  }
`

export interface DiscountsHomeQueryInput {
  draft: boolean
}

export interface DiscountsHomeQueryOutput {
  DiscountsHome: {
    content: BaseOfferBlock[]
    meta: {
      title: string
      description: string
    }
  }
}

export const useDiscountsHomeQuery = (
  input: DiscountsHomeQueryInput,
  options?: QueryHookOptions<DiscountsHomeQueryOutput, DiscountsHomeQueryInput>
) =>
  usePersistedCacheQuery<DiscountsHomeQueryOutput, DiscountsHomeQueryInput>(query, {
    variables: input,
    ...options,
  })

export const fetchDiscountHomeQuery = { query }
